var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailedPaymentOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 255,
    viewBox: "0 0 283 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162.699,
    cy: 150.184,
    r: 104.816,
    fill: "#F2F3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.687 252.171L65.8713 226.291C59.6787 223.256 58.3438 215.012 63.2625 210.178L170.99 104.315C173.618 101.734 177.452 100.805 180.969 101.899L257.616 125.738C265.218 128.103 267.144 137.97 260.988 143.019L129.429 250.924C126.401 253.407 122.203 253.894 118.687 252.171Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.881 240.411L65.8908 213.501C59.692 210.467 58.3565 202.215 63.2821 197.381L174.4 88.3334C177.265 85.5221 181.533 84.696 185.24 86.2352L256.209 115.706C263.14 118.584 264.549 127.787 258.796 132.606L131.699 239.094C128.67 241.631 124.43 242.148 120.881 240.411Z",
    fill: "#3681D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.059 28.8436C60.6567 26.6129 63.4451 25.8658 65.0781 27.4988L122.819 85.2399C124.452 86.8729 123.705 89.6613 121.474 90.259L42.5985 111.394C40.3678 111.991 38.3266 109.95 38.9243 107.719L60.059 28.8436Z",
    fill: "#FA5252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.72 38.9243C109.95 38.3266 111.992 40.3679 111.394 42.5986L90.2591 121.474C89.6614 123.705 86.873 124.452 85.24 122.819L27.4989 65.0782C25.8659 63.4452 26.613 60.6568 28.8437 60.0591L107.72 38.9243Z",
    fill: "#FA5252"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.475 60.059C123.705 60.6567 124.453 63.4451 122.82 65.0781L65.0785 122.819C63.4455 124.452 60.6571 123.705 60.0594 121.474L38.9247 42.5985C38.3269 40.3678 40.3682 38.3266 42.5989 38.9243L121.475 60.059Z",
    fill: "#FA5252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2399 27.4986C86.8729 25.8656 89.6613 26.6128 90.259 28.8435L111.394 107.719C111.991 109.95 109.95 111.991 107.719 111.394L28.8436 90.2588C26.6129 89.6611 25.8658 86.8727 27.4988 85.2397L85.2399 27.4986Z",
    fill: "#FA5252"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5762 86.8251L86.8246 62.5767",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8246 86.8252L62.5762 62.5767",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.616 19.5552C225.616 19.5552 180.248 39.8926 184.942 96.2116L240.478 122.807C236.568 64.1411 282.718 46.1503 282.718 46.1503L225.616 19.5552Z",
    fill: "#C8E2FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184.601 96.2114L240.138 122.807",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.0591,
    y: 185.471,
    width: 43.0594,
    height: 1.56442,
    transform: "rotate(28.7274 99.0591 185.471)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112.638,
    y: 210.354,
    width: 43.0594,
    height: 1.56442,
    transform: "rotate(-45 112.638 210.354)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109.335,
    y: 173.443,
    width: 42.005,
    height: 1.56442,
    transform: "rotate(28.7274 109.335 173.443)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98.9492,
    y: 199.737,
    width: 42.005,
    height: 1.56442,
    transform: "rotate(-45 98.9492 199.737)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedPaymentOrder);
export default __webpack_public_path__ + "static/media/failed-payment-order.1fe37dda8d48be9fe0933fdaa733eb5b.svg";
export { ForwardRef as ReactComponent };